module.exports = __webpack_public_path__ + "img/组 4.213c65ad.png";